import { __decorate, __param } from 'tslib';
import { InjectionToken, inject, Inject, Input, Directive, forwardRef, NgModule, ChangeDetectorRef } from '@angular/core';
import { TuiController, tuiDefaultProp, TuiDestroyService } from '@taiga-ui/cdk';
import { TUI_HINT_OPTIONS } from '@taiga-ui/core/directives/hint';
import { watchedControllerFactory } from '@taiga-ui/core/providers';

import * as ɵngcc0 from '@angular/core';
const TUI_HINT_CONTROLLER = new InjectionToken('Controls configuration of hints', {
    factory: () => new TuiHintControllerDirective(inject(TUI_HINT_OPTIONS)),
});

var TuiHintControllerDirective_1;
// TODO: v2.0 use in Charts
let TuiHintControllerDirective = TuiHintControllerDirective_1 = class TuiHintControllerDirective extends TuiController {
    constructor(options) {
        super();
        this.options = options;
        // TODO: Remove null in 3.0
        this.content = null;
        this.direction = this.options.direction;
        this.mode = this.options.mode;
        this.showDelay = this.options.tuiHintShowDelay;
        this.hideDelay = this.options.tuiHintHideDelay;
    }
};
TuiHintControllerDirective.ɵfac = function TuiHintControllerDirective_Factory(t) { return new (t || TuiHintControllerDirective)(ɵngcc0.ɵɵdirectiveInject(TUI_HINT_OPTIONS)); };
TuiHintControllerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiHintControllerDirective, selectors: [["", "tuiHintContent", ""]], inputs: { content: ["tuiHintContent", "content"], direction: ["tuiHintDirection", "direction"], mode: ["tuiHintMode", "mode"], showDelay: ["tuiHintShowDelay", "showDelay"], hideDelay: ["tuiHintHideDelay", "hideDelay"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_HINT_CONTROLLER,
                useExisting: forwardRef(() => TuiHintControllerDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
TuiHintControllerDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_HINT_OPTIONS,] }] }
];
__decorate([
    Input('tuiHintContent'),
    tuiDefaultProp()
], TuiHintControllerDirective.prototype, "content", void 0);
__decorate([
    Input('tuiHintDirection'),
    tuiDefaultProp()
], TuiHintControllerDirective.prototype, "direction", void 0);
__decorate([
    Input('tuiHintMode'),
    tuiDefaultProp()
], TuiHintControllerDirective.prototype, "mode", void 0);
__decorate([
    Input('tuiHintShowDelay'),
    tuiDefaultProp()
], TuiHintControllerDirective.prototype, "showDelay", void 0);
__decorate([
    Input('tuiHintHideDelay'),
    tuiDefaultProp()
], TuiHintControllerDirective.prototype, "hideDelay", void 0);
TuiHintControllerDirective = TuiHintControllerDirective_1 = __decorate([ __param(0, Inject(TUI_HINT_OPTIONS))
], TuiHintControllerDirective);

let TuiHintControllerModule = class TuiHintControllerModule {
};
TuiHintControllerModule.ɵfac = function TuiHintControllerModule_Factory(t) { return new (t || TuiHintControllerModule)(); };
TuiHintControllerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiHintControllerModule });
TuiHintControllerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiHintControllerDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiHintContent]',
                providers: [
                    {
                        provide: TUI_HINT_CONTROLLER,
                        useExisting: forwardRef(() => TuiHintControllerDirective_1)
                    },
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_HINT_OPTIONS]
            }] }]; }, { content: [{
            type: Input,
            args: ['tuiHintContent']
        }], direction: [{
            type: Input,
            args: ['tuiHintDirection']
        }], mode: [{
            type: Input,
            args: ['tuiHintMode']
        }], showDelay: [{
            type: Input,
            args: ['tuiHintShowDelay']
        }], hideDelay: [{
            type: Input,
            args: ['tuiHintHideDelay']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiHintControllerModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiHintControllerDirective],
                exports: [TuiHintControllerDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiHintControllerModule, { declarations: [TuiHintControllerDirective], exports: [TuiHintControllerDirective] }); })();

const TUI_HINT_WATCHED_CONTROLLER = new InjectionToken('watched hint controller');
// TODO: remove in ivy compilation
const HINT_CONTROLLER_FACTORY = watchedControllerFactory;
const HINT_CONTROLLER_PROVIDER = [
    TuiDestroyService,
    {
        provide: TUI_HINT_WATCHED_CONTROLLER,
        deps: [TUI_HINT_CONTROLLER, ChangeDetectorRef, TuiDestroyService],
        useFactory: HINT_CONTROLLER_FACTORY,
    },
];

/**
 * Generated bundle index. Do not edit.
 */

export { HINT_CONTROLLER_FACTORY, HINT_CONTROLLER_PROVIDER, TUI_HINT_CONTROLLER, TUI_HINT_WATCHED_CONTROLLER, TuiHintControllerDirective, TuiHintControllerModule };

